// B2a — the signed-in user's landing route comes from the backend (`user.home_route`, services/role_home.py), which
// only returns a route that role can open. `/home` (workspace home) is open to every signed-in role.
export const WORKSPACE_HOME = "/home";

export function homeRouteFor(user) {
  return (user && user.home_route) || WORKSPACE_HOME;
}
